import { createSlice } from "@reduxjs/toolkit";

const Singleproductslice = createSlice({
    name : "singleproduct",
    initialState : {
        loading : false,
        singleproduct : []
    },
    reducers:{
        singleproductrequest : (state,action)=>{
            state.loading = true
            console.log(state.loading)

        },
        singleproductsuccess : (state,action)=>{
            state.loading = false
            state.singleproduct = action.payload
            console.log(state.loading)
            console.log(state.singleproduct)
            
        },
        singleproductfail : (state,action) =>{
            state.loading = false

        }
    }
})
export default Singleproductslice;